import { ErrorMessageContents } from '../../../helpers/hub'
import { AggressAttempt } from './types'

export const aggressAttemptFetch = () =>
  ({ type: 'aggressAttempts.fetch' } as const)
type AggressAttemptFetchAction = ReturnType<typeof aggressAttemptFetch>

export const aggressAttemptAddAggressAttempt = (
  aggressAttempts: AggressAttempt[]
) =>
  ({
    type: 'aggressAttempts.addAggressAttempt',
    payload: aggressAttempts
  } as const)
export type AggressAttemptAddAggressAttemptAction = ReturnType<
  typeof aggressAttemptAddAggressAttempt
>

export const aggressAttemptFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'aggressAttempts.fetchFail', payload: error, error: true } as const)
export type AggressAttemptFetchFailAction = ReturnType<
  typeof aggressAttemptFetchFail
>

export const unsubscribeFromAggressAttempt = () =>
  ({ type: 'aggressAttempts.fetchCancel' } as const)
export type AggressAttemptFetchCancelAction = ReturnType<
  typeof unsubscribeFromAggressAttempt
>

export type AggressAttemptAction =
  | AggressAttemptFetchAction
  | AggressAttemptAddAggressAttemptAction
  | AggressAttemptFetchFailAction
  | AggressAttemptFetchCancelAction
